// extracted by mini-css-extract-plugin
module.exports = {"root":"ResultsList_root__2QARk","label":"ResultsList_label___xCbP","divider":"ResultsList_divider__sKHRe"};